import React, { useState } from "react";

// This component uses functional components and hooks.
// It is styled with Tailwind CSS to match the provided site's color scheme.
// The links are configured to open in new tabs with the specified routes.

interface DisclosureAgreementProps {
  onAgree: () => void;
}

const DisclosureAgreement: React.FC<DisclosureAgreementProps> = ({ onAgree }) => {
  const [checked, setChecked] = useState(false);

  // Function to handle opening a link in a new tab using the specified URL
  const handleLinkClick = (url: string) => {
    window.open(`${process.env.REACT_APP_CURRENT_URL}${url}`, "_blank", "noopener, noreferrer");
  };

  return (
    <div className="bg-white rounded-lg shadow-xl p-8 max-w-xl mx-auto my-10">
      {/* Container for the checkbox and text */}
      <div className="flex items-start gap-3">
        {/* The actual checkbox input */}
        <input
          type="checkbox"
          id="agreement-checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="mt-1 w-5 h-5 text-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-purple-500"
        />
        {/* The label and list of links */}
        <label htmlFor="agreement-checkbox" className="flex flex-col text-sm text-gray-700">
          <span className="font-medium">By checking this box you:</span>
          {/* List of disclosure agreements */}
          <ul className="list-disc ml-6 mt-2 space-y-2">
            <li>
              Agree to use electronic records and signatures and confirm you have read the {" "}
              <a
                href="/legal/sign/electronic-signature-consent"
                target="_blank"
                rel="noopener noreferrer"
                // onClick={() => handleLinkClick("/legal/sign/electronic-signature-consent")}
                className="text-purple-600 hover:text-purple-800 visited:text-gray-600"
              >
                Electronic Signature Consent
              </a>
            </li>
            <li>
              Agree to Waivera's {" "}
              <a
                href="/legal/sign/tos"
                target="_blank"
                rel="noopener noreferrer"
                // onClick={() => handleLinkClick("/legal/sign/tos")}
                className="text-purple-600 hover:text-purple-800 visited:text-gray-600"
              >
                Terms of Service
              </a>
            </li>
            <li>
              Confirm you have read Waivera's {" "}
              <a
                href="/legal/sign/security-compliance-terms"
                target="_blank"
                rel="noopener noreferrer"
                // onClick={() => handleLinkClick("legal/sign/security-compliance-terms")}
                className="text-purple-600 hover:text-purple-800 visited:text-gray-600"
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </label>
      </div>

      {/* Accept & Continue button */}
      <button
        onClick={onAgree}
        disabled={!checked}
        className={`w-full mt-6 py-3 px-4 rounded-lg font-bold text-white transition duration-200 ease-in-out
          ${!checked ? 'bg-gray-400 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700'}`
        }
      >
        Accept & Continue
      </button>
    </div>
  );
};

export default DisclosureAgreement;
